export const SendMethodLabels: { [key: string]: string } = {
  email: 'Email PDF',
  ftp: 'FTP',
  download: 'Bulk Add File(s)',
};
